
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from "react";
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getSwarmSubscriptionRequestHorseRacingTimes } from "../../../helpers/terminalRequests/horseRacing";
import { createSelector } from "reselect";
import { getGameData } from "../../../helpers/horseRacing";
import { withRouter } from 'react-router';
import lodash from 'lodash';
import moment from 'moment';
let ctx;
class HorseRacingGameDays extends Component {
    constructor (props) {
        super(props);
        this.state = {};
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleGameClick = this.handleGameClick.bind(this);
    }

    /**
     * @name selectGame
     * @param {string} id
     * @description Select game by id
     * @return {function}
     * */
    handleDayClick (day) {
        const { newData } = this.props;
        const { selectedGameId } = this.state;
        ctx.router.replace(this.props.location.pathname.replace(selectedGameId, newData[day][0].id));
    }
    handleGameClick (gameId) {
        const { selectedGameId } = this.state;
        ctx.router.replace(this.props.location.pathname.replace(selectedGameId, gameId));
    }
    static getDerivedStateFromProps (props, state) {
        if (props.loaded && props.data && props.params.gameId) {
            const game = props.data.find(item => (item.id || -1).toString() === props.params.gameId) || props.data.find(item => item.id === props.firstGameId);
            return {
                selectedGameId: props.params.gameId,
                day: moment.unix(new Date(game && game.start_ts)).format("DD-MM-YYYY")
            };
        }
        return {
            selectedGameId: props.params.gameId
        };
    }
    // UNSAFE_componentWillReceiveProps (nextProps) {
    //     const { data, loaded, day } = nextProps, { selectedEventId } = this.state;
    //     const firstGameId = Object.keys(data || {})[0];
    //     if (data && firstGameId) {
    //         if ((!selectedEventId || (selectedEventId !== firstGameId))) {
    //             this.setState({ selectedEventId: +firstGameId });
    //         }
    //     }
    //     if (loaded && !day) {
    //         const newData = lodash.groupBy(Object.values(data || {}), (item) => {
    //             const temp = new Date(item.start_ts);
    //             return moment.unix(temp).format("DD-MM-YYYY");
    //         });
    //         const day = Object.keys(newData).sort()[0];
    //         console.log(day, newData);
    //         this.selectGame(day)();
    //     }
    // }
    render () {
        ctx = this.props;
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

HorseRacingGameDays.propTypes = {
    data: PropTypes.array,
    loaded: PropTypes.bool,
    selectDay: PropTypes.func,
    day: PropTypes.string
};

const mapStateToProps = (_, ownParams) => {
    const key = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestHorseRacingTimes(ownParams));
    return createSelector(
        [
            state => state.swarmData.data[key] && JSON.stringify(state.swarmData.data[key]),
            state => state.swarmData.loaded[key]
        ],
        (data, loaded) => {
            let gameCount, firstGameId, temp, newData = {};            
            if (data) {
                temp = Object.values(JSON.parse(data || '{}').game).sort((a, b) => a.start_ts - b.start_ts)
                if (temp && temp.length > 0 && loaded) {
                    gameCount = temp.length;
                    firstGameId = temp[0].id;
                    newData = lodash.groupBy(Object.values(temp), (item) => {
                        const temp = new Date(item.start_ts);
                        return moment.unix(temp).format("DD-MM-YYYY");
                    });
                } else if (temp && temp.length === 0) {
                    gameCount = 0;
                }
            }
            return {
                gameCount,
                loaded,
                firstGameId,
                selectorKey: key,
                data: temp,
                newData
            };
        });
};

export default withRouter(connect(mapStateToProps)(SwarmDataMixin({
    Component: HorseRacingGameDays,
    ComponentWillMount: function () {
        this.swarmSubscriptionRequest = getSwarmSubscriptionRequestHorseRacingTimes(this.props);
        this.swarmDataKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestHorseRacingTimes(this.props));
    },
    ComponentWillReceiveProps: function (nextProps) {
        if (!nextProps.params.gameId && nextProps.firstGameId) {
            if (ctx && nextProps.location.pathname.indexOf(nextProps.firstGameId) === -1) {
                return ctx.router.replace(nextProps.location.pathname + "/" + nextProps.firstGameId);
            }
        }
    }
})));